// extracted by mini-css-extract-plugin
export default {"box":"Search_box__P61O3","input":"Search_input__F+KgE","clear-button":"Search_clear-button__i7shH","icon":"Search_icon__rNnK5"};